import { useEffect } from 'react';
import { usePathname } from 'expo-router';
import { useRouteStore } from '@/store';

export function useRouteSync() {
  const pathname = usePathname();
  const {
    setCurrentLibraryId,
    setCurrentTagId,
    setCurrentCollectionId,
    setCurrentAgentId,
    setCurrentModelId
  } = useRouteStore(state => state.actions);

  useEffect(() => {
    // Reset all states first
    setCurrentLibraryId(null);
    setCurrentTagId(null);
    setCurrentCollectionId(null);
    setCurrentAgentId(null);
    setCurrentModelId(null);

    // Parse the current route
    // Conversation detail routes use /c/:id. Keep the legacy /library/:id
    // shape for compatibility, but do not clear the active chat on /c routes.
    const libraryMatch = pathname.match(/^\/(?:c|library)\/([^\/]+)/);
    const tagMatch = pathname.match(/^\/tag\/([^\/]+)/);
    const collectionMatch = pathname.match(/^\/collections\/([^\/]+)/);
    const agentMatch = pathname.match(/^\/g\/([^\/]+)/);
    const modelMatch = pathname.match(/^\/m\/([^\/]+)/);

    // Set the appropriate state based on the route
    if (libraryMatch) {
      setCurrentLibraryId(libraryMatch[1]);
    } else if (tagMatch) {
      setCurrentTagId(tagMatch[1]);
    } else if (collectionMatch) {
      setCurrentCollectionId(collectionMatch[1]);
    } else if (agentMatch) {
      setCurrentAgentId(agentMatch[1]);
    } else if (modelMatch) {
      setCurrentModelId(modelMatch[1]);
    }

  }, [pathname, setCurrentLibraryId, setCurrentTagId, setCurrentCollectionId, setCurrentAgentId, setCurrentModelId]);
} 